import { HOME_PAGE_LOADED, HOME_PAGE_UNLOADED, ACCOUNT_LIST_EXPORT, CLEAR_PROPS } from '../constants/actionTypes';
import { BASE_COIN_SYMBOL } from '../constants/config'

export default (state = {}, action) => {
  switch (action.type) {
    case HOME_PAGE_LOADED:
      return {
        ...state,
        user_count: action.payload.user_count,
        // exchange_flux: BASE_COIN_SYMBOL === 'XIF' ? null : action.payload.exchange_flux,
        // account: BASE_COIN_SYMBOL === 'XIF' ? action.payload.master_account : action.payload.spnc_master_account,
        // symbol_amounts: BASE_COIN_SYMBOL === 'XIF' ? null : action.payload.symbol_amounts,
        // sold_coins: BASE_COIN_SYMBOL === 'XIF' ? Math.abs(action.payload.sold_coins) : null,
      };
    case HOME_PAGE_UNLOADED:
      return {};
    case ACCOUNT_LIST_EXPORT:
      return {
        ...state,
        csvData: action.payload,
        symbol: action.symbol
      }
    case CLEAR_PROPS:
      return {
        ...state,
        csvData: null
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/home.js